import { render, staticRenderFns } from "./coursesIbought.vue?vue&type=template&id=623394ec&scoped=true"
import script from "./coursesIbought.vue?vue&type=script&lang=js"
export * from "./coursesIbought.vue?vue&type=script&lang=js"
import style0 from "./coursesIbought.vue?vue&type=style&index=0&id=623394ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623394ec",
  null
  
)

export default component.exports